import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { environment } from '../../../environments/environment';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const urlsToExclude = [(environment.CompanyAPI + '/api/v1/companies/match/files/upload')];
  const isAutoRefresh = req.headers.get('X-Auto-Refresh') === 'true';
  const showMainLoader =
    !urlsToExclude.includes(req.url) && !isAutoRefresh;

  if (showMainLoader) {
    loaderService.ongoingRequests.update(current => ++current);
  }

  return next(req).pipe(
    finalize(() => {
      if (showMainLoader && loaderService.ongoingRequests() > 0) {
        loaderService.ongoingRequests.update(current => --current);
      }
    })
  );
};
